import { requestSync } from './pure/request'
import Signal from './pure/Signal'

class Store
{
    constructor()
    {
        this._initBindedVars()
        this.onSlideScroll = new Signal()
    }

    _initBindedVars()
    {
        this.global = {
            isConnected: false,

            color: 'red',
            isMenuOpen: false,
            routes: [],
            currentSlideID: -1,
            isDescending: true,
            background: 'black',

            modalMessage: false,
            modalShare: false,
            modalVideo: false
        }
    }

    openModal(intro = [], paragraphs = [])
    {
        this.global.modalMessage = { intro, paragraphs }
    }

    closeModal()
    {
        this.global.modalMessage = false
    }

    connect()
    {
        this.global.isConnected = true
        this.loadContent()
    }

    _setSlideContent(numStr)
    {
        const data = requestSync('/content/slide-' + numStr + '.json')
        if (data.success === false)
        {
            console.error(data.message)
        }
        else
        {
            this.global['slide' + numStr] = data
        }
    }

    loadContent()
    {
        // Use synchronus request to simplify process
        this._setSlideContent('04')
        this._setSlideContent('05')
        this._setSlideContent('08')
        this._setSlideContent('09')
        this._setSlideContent('10')
        this._setSlideContent('11')
        this._setSlideContent('12')
        this._setSlideContent('13')
    }
}

const store = new Store()

export default store
